var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.componente != null)?_c(_vm.componente,{tag:"component"}):_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(" Selecione um modo de uso na página de configurações ")]),_c('vue-confirm-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }